import { NOTIFICATION_DELETE_ALL_ITEMS } from 'app/utils/constants';

export default function notificationReducer(
    state = {
        items: [],
    },
    action
) {
    switch (action.type) {
        case 'NOTIFICATION_ADD_ITEM': {
            return {
                ...state,
                items: [...state.items, action.payload],
            };
        }
        case 'NOTIFICATION_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                items: state.items.filter((notification) => notification.id !== id),
            };
        }
        case NOTIFICATION_DELETE_ALL_ITEMS: {
            return {
                ...state,
                items: [],
            };
        }
        default:
            return state;
    }
}
